import { CIDService } from "src/app/services/common/cid.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSelectChange } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { TranslateService } from "@ngstack/translate";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IBranch } from "src/app/interfaces/branch";
import { ICourseHistory } from "src/app/interfaces/courseHistory";
import { CourseHistoryService } from "src/app/services/http/business/course-history/course-history.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { BIDService } from "src/app/services/common/bid.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-course-history-entry",
  templateUrl: "./course-history-entry.component.html",
  styleUrls: ["./course-history-entry.component.css"]
})
export class CourseHistoryEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  errors = new Array();
  branchList: IBranch[];
  // branchSelected: string;
  companySelected: string;
  companyList: ICompany[];

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private bidService: BIDService,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private errorService: ErrorsService,
    private branchService: BranchService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private courseHistoryService: CourseHistoryService,
    private dialogRef: MatDialogRef<CourseHistoryEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICourseHistory
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    if (this.data && this.data.Description) {
      this.form.controls.company.setValue(this.cidService.getCID());
      this.form.controls.branch.setValue(this.bidService.getBID());
    }
  }

  createForm() {
    this.form = this.fb.group({
      company: [this.bidService.getBID(), Validators.compose([Validators.required])],
      branch: [null, Validators.compose([Validators.required])],
      Description: [
        this.data ? this.data.Description : null,
        Validators.compose([Validators.required])
      ],
      Id: [this.data ? this.data.Id : 0]
    });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  loadBranch(e: MatSelectChange) {
    this.cidService.setCID(e.value);
    this.bidService.setBID("");
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
    });
  }
  BID(e: MatSelectChange) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  onClose() {
    this.dialogRef.close();
    // this.courseHistoryService.fire();
  }

  submit(form: ICourseHistory) {
    if (this.data && this.data.Description) {
      this.courseHistoryService.edit(form).subscribe(() => {
        this.courseHistoryService.fire();
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      });
    } else {
      this.courseHistoryService.add(form).subscribe(
        () => {
          this.courseHistoryService.fire();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }
}
